import React, { Fragment, useState, useEffect } from 'react'
import clsx from 'clsx'
import styled from 'styled-components'
import { sortableContainer, sortableElement, sortableHandle } from 'react-sortable-hoc'
import { withStyles } from '@material-ui/core/styles'
import {
  makeStyles,
  Avatar,
  Card,
  CardHeader,
  CardContent,
  Typography,
  IconButton,
  GridList,
  Link,
  Tooltip,
  TextField,
  Grid,
  InputAdornment,
  MenuList,
  Paper,
  Menu,
  MenuItem,
  Icon,
  Divider,
  Button,
  SvgIcon,
  Fade,
  Collapse,
  Grow,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Accordion,
  AccordionSummary,
  CircularProgress,
  Select,
  InputBase,
  FormControl,
  InputLabel,
} from '@material-ui/core'
import EventAvailableIcon from '@material-ui/icons/EventAvailable'
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined'
import DragHandleIcon from '@material-ui/icons/DragHandle'
import TrendingUpIcon from '@material-ui/icons/TrendingUp'
import TrendingDownIcon from '@material-ui/icons/TrendingDown'
import DashboardIcon from '@material-ui/icons/Dashboard'
import CloseIcon from '@material-ui/icons/Close'
import SearchIcon from '@material-ui/icons/Search'
import AddToQueueIcon from '@material-ui/icons/AddToQueue'
import AppsIcon from '@material-ui/icons/Apps'
import SaveIcon from '@material-ui/icons/Save'
import RestorePageIcon from '@material-ui/icons/RestorePage'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import LocalShippingIcon from '@material-ui/icons/LocalShipping'
import LocalFloristIcon from '@material-ui/icons/LocalFlorist'
import Cookies from 'js-cookie'
import WelcomeBoard from './WelcomeBoard'
import arrayMove from 'array-move'
import { RiHome4Fill, RiMore2Fill, RiFilter3Fill } from 'react-icons/ri'
import { BiCaretDown, BiCaretUp, BiFilter } from 'react-icons/bi'

import '../../assets/grid.css'

const base_url = "https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm"

function MoreIcon(props) {
  return(
    <SvgIcon {...props}>
      <path fill="currentColor" d="M12,2A10,10 0 0,1 22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2M12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12A8,8 0 0,0 12,4M12,10.5A1.5,1.5 0 0,1 13.5,12A1.5,1.5 0 0,1 12,13.5A1.5,1.5 0 0,1 10.5,12A1.5,1.5 0 0,1 12,10.5M7.5,10.5A1.5,1.5 0 0,1 9,12A1.5,1.5 0 0,1 7.5,13.5A1.5,1.5 0 0,1 6,12A1.5,1.5 0 0,1 7.5,10.5M16.5,10.5A1.5,1.5 0 0,1 18,12A1.5,1.5 0 0,1 16.5,13.5A1.5,1.5 0 0,1 15,12A1.5,1.5 0 0,1 16.5,10.5Z" />
    </SvgIcon>
  )
}

const useStyles = makeStyles(theme => ({
  banner: {
    [theme.breakpoints.up('md')]: {
      display: 'flex',
    }
  },
  welcome: {
    width: '100%',
    color: 'white',
    background: `linear-gradient(to right bottom, #039be5, #dcedc8)`,
    marginBottom: '-20px',
  },
  welcomeDark: {
    width: '100%',
    color: 'white',
    background: `linear-gradient(to right bottom, rgba(3,154,229, 0.4), rgba(220, 237, 200, 0.4))`,
    border: '1px solid #3bb2b4',
  },
  grid: {
    alignItems: 'center',
    marginTop: '20px'
  },
  pageTitle: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '17px',
    fontWeight: 'light',
    color: 'rgba(115, 115, 115, 0.9)',
    alignItems: 'center',
    display: 'inline-flex',
    marginTop: '25px',
  },
  pageTitleDark: {
    fontFamily: 'Roboto, sans-serif',
    fontSize: '17px',
    fontWeight: 'light',
    color: 'rgba(255, 255, 255, 0.9)'
  },
  pageIcon: {
    fontSize: '17px',
    color: 'rgba(115, 115, 115, 0.9)',
  },
  pageIconDark: {
    fontSize: '15px',
    color: 'rgba(255, 255, 255, 0.9)',
    marginTop: '5px',
  },
  search: {
  },
  iconbutton: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: '#4ab8bb'
    }
  },
  alerts: {
    borderRadius: '4px',
    backgroundColor: 'rgba(255, 255, 255, 0.4)',
    width: '100%',
    height: '75px',
    marginTop: '10px',
    overflowY: 'auto',
  },
  alertAvatar: {
    width: '35px',
    height: '35px'
  },
  alertMessage: {
    margin: '10px 10px 0px 10px',
    width: '80%',
    display: 'inline-flex',
    alignItems: 'center',
    [theme.breakpoints.down('lg')]: {
      margin: '2px 10px 0px 10px',
    },
  },
  menuItem: {
    width: 400,
    justifyContent: 'space-between'
  },
  socialMedia: {
    display: 'flex',
    height: 275,
    width: 400,
    marginTop: '47px',
    border: '2px solid rgba(38, 76, 154, 0.7)',
    [theme.breakpoints.down('lg')] : {
      width: 300,
    }
  },
  bulletin: {
    height: 275,
    width: 400,
    marginTop: '47px',
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    border: '2px solid rgba(235, 192, 84, 0.8)',
    overflowY: 'auto',
    [theme.breakpoints.down('lg')] : {
      width: 300,
    }
  },
  hidden: {
    display: 'none'
  }
}))

// const CustomButton = withStyles({
//   root: {
//     boxShadow: 'none',
//     textTransform: 'none',
//     fontSize: 12,
//     border: '0px',
//     color: '#011689',
//     height: '100%',
//     '&:hover': {
//       backgroundColor: 'transparent',
//       color: '#0072ff',
//       border: '0px',
//       boxShadow: 'none',
//     },
//     '&:active': {
//       boxShadow: 'none'
//     },
//     '&:focus': {
//       boxShadow: 'none',
//     }
//   }
// })(Button)

const StyledTextField = styled(TextField)({
  '& label': {
    color: '#fff',
  },
  '& label.Mui-focused': {
    color: '#25aee1',
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',
    borderRadius: "10px",
    '&:hover fieldset': {
      borderColor: '#25aee1',
    },
    '& fieldset': {
      color: '#fff',
      borderColor: '#fff'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#25aee1',
      color: '#fff',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#fff',
    backgroundColor: 'transparent',
  }
})

const StyledTextFieldLt = styled(TextField)({
  '& label': {
    color: '#6e6e6e',
  },
  '& label.Mui-focused': {
    color: '#25aee1',
  },
  '& .MuiOutlinedInput-root': {
    color: '#6e6e6e',
    borderRadius: "10px",
    '&:hover fieldset': {
      borderColor: '#25aee1',
    },
    '& fieldset': {
      color: '#6e6e6e',
      borderColor: '#6e6e6e'
    },
    '&.Mui-focused fieldset': {
      borderColor: '#25aee1',
      color: '#6e6e6e',
    },
  },
  '& .MuiOutlinedInput-input': {
    color: '#6e6e6e',
    backgroundColor: 'transparent',
  }
})

const StyledSelect = styled(InputBase)(({theme}) => ({
  'label + &': {
    color: "#fff",
  },
  '& .MuiInputBase-input': {
    borderRadius: 4,
    position: 'relative',
    border: '1px solid #ced4da',
    fontSize: 16,
    color: "#fff",
    padding: '10px 26px 10px 12px',
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))

const DragHandle = sortableHandle(() => <span><DragHandleIcon className="home-icons" /></span>)

const SortableItem = sortableElement(({value, removePanel, darkMode, itemsLength}) => {
    const { icon, title, color, colorDark, subheader, panel, path} = value
    return (
      <Fade in={true} timeout={500}>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={4}>
          {console.log(darkMode)}
          <Card
            // className={itemsLength > 1 ? "card" : "single-card"}
            className={clsx("home-panel", {["panel-dark"]: darkMode, ["panel-light"]: !darkMode})}
            style={{border: `2px solid ${color}`}}
          >
            <CardHeader
              action={itemsLength > 1 ?
                <IconButton size="small" className="more-options" disableRipple disableFocusRipple>
                  <RiMore2Fill />
                </IconButton>
                // <div style={{display: 'flex', alignItems: 'center'}}>
                //   <Tooltip title="Hold to drag panel">
                //     <IconButton style={{backgroundColor: 'transparent'}} size='small' disableRipple>
                //       <DragHandle  />
                //     </IconButton>
                //   </Tooltip>
                //   <Tooltip title="Remove panel">
                //     <IconButton
                //       onClick={title => removePanel(title)}
                //       style={{backgroundColor: 'transparent'}}
                //       size='small'
                //       disableRipple
                //     >
                //       <CloseIcon className="home-icons" />
                //     </IconButton>
                //   </Tooltip>
                // </div>
                : <div />
              }
              title={
                <div>
                  <div className="title-group">
                    <Icon className="home-icons avatar">{icon}</Icon>
                    <Typography variant="body2" className="title-text">
                      {/* <Link href={"/"} color="inherit" className="link">{title.toUpperCase()}</Link> */}
                      <Link href={itemsLength > 1 ? path : null} color="inherit" className="link">{title.toUpperCase()}</Link>
                    </Typography>
                  </div>
                  <Typography variant="caption" className="subheader">{subheader}</Typography>
                </div>
              }
              className="home-card-header"
              style={{
                backgroundColor: colorDark,
                borderBottom: `2px solid ${color}`,
              }}
            />
            <CardContent>
              {panel}
            </CardContent>
          </Card>
        </Grid>
      </Fade>
    )
  }
)

const SortableContainer = sortableContainer(({children}) => {
  return (
    <Grid
      container
      columns={{xs: 1, sm: 1, md: 2, lg: 3, xl: 3}}
      spacing={3}
      style={{
        justifyContent: 'center',
        marginTop: 15,
      }}
    >
      {children}
    </Grid>
  )
})

export default function HomeGrid({homeList, user, layout, dbO, darkTheme}) {
  const classes = useStyles()
  const usersList = [44, 1045, 370,]
  const token = Cookies.get("token")
  const [search, setSearch] = useState('')
  const [openSearch, setOpenSearch] = useState(null)
  const [isSorted, setIsSorted] = useState(false)
  const [sortedList, setSortedList] = useState(null)
  const [defaultList, setTheDefault] = useState(false)
  const [hidden, setHidden] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [anchor, setAnchor] = useState(null)
  const [sortVal, setSortVal] = useState("DEFAULT")
  // const openSearchList = Boolean(anchor)

  const getSortedHomeList = (layout, homeList) => {
    if(layout && layout.length > 0) {
      if(layout.length < homeList.length) {
        let filteredList = homeList.filter(({id}, i) => layout.includes(id))
        filteredList.sort((a,b) => {
          return layout.indexOf(a.id) - layout.indexOf(b.id)
        })

        setSortedList(filteredList)
        setTheDefault(true)
      } else {
        homeList.sort((a,b) => {
          return layout.indexOf(a.id) - layout.indexOf(b.id)
        })

        setSortedList(homeList)
        setTheDefault(true)
      }
    } else {
      setSortedList(homeList)
    }
  }

  // const trackHomePage = () => {
  //   const request = fetch(`${base_url}/pageviews/add?display=dashboard_home&screen_name=dashboard_home`, {
  //     method: "POST",
  //     headers: {
  //       token: token,
  //     }
  //   })
  //
  //   if(JSON.parse(localStorage.getItem("currentUser"))[0].username.toUpperCase().includes("USER")) {
  //     request.then(response => {
  //       if(response.ok === true) return response.json()
  //     })
  //     .catch(error => console.log(error))
  //   }
  // }

  useEffect(() => getSortedHomeList(layout, homeList), [homeList])
  // useEffect(() => trackHomePage(), [])

  const updateSearch = (e, row) => {
    let {value} = e.target

    if(value) {
      setSearch(value.substr(0, 25))
      setHidden(true)
    } else if(row) {
      const { title } = row
      setSearch(title)
      setHidden(true)
      setMenuOpen(false)
    } else {
      setSearch('')
      setHidden(false)
    }
  }

  const openSearchList = (e) => {
    const {currentTarget} = e
    setOpenSearch(currentTarget)
  }

  const closeSearchList = () => {
    console.log('not focused')
    // setAnchor(null)
  }

  const handleRemovePanel = (valueTitle) => {
    let newList = sortedList.filter(({title}) => {
      return title !== valueTitle
    })

    setSortedList(newList)
    setIsSorted(true)
  }

  const handleAddPanel = (e, row) => {
    let joined = sortedList.concat(row)
    setSortedList(joined)
    setIsSorted(true)
  }

  const onSortEnd = ({oldIndex, newIndex}) => {
    setSortedList(arrayMove(sortedList, oldIndex, newIndex))
    setIsSorted(true)
  }

  const handleTogglePanelMenu = (e) => {
    setAnchor(e.currentTarget)
  }

  const handleTogglePanelMenuClose = () => {
    setAnchor(null)
  }

  const handleOpenSortMenu = (e) => {
    const { currentTarget } = e
    setAnchor(currentTarget)
  }

  const handleCloseSortMenu = () => {
    setAnchor(null)
  }

  const handleSortValueChange = (e, value) => {
      setSortVal(value)

      handleCloseSortMenu()
  }

  // handleSaveGrid = (e, filteredItems) => {
  //   let sortingArr = filteredItems.map(item => item.id).join()
  //
  //   fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/admin/updateLayout?layout=${filteredItems.map(item => item.id).join()}`, {
  //     method: 'POST',
  //     headers: {
  //       'token': Cookies.get('token'),
  //     },
  //   })
  //   .then(response => {
  //     if(response.ok === true) {
  //       return response.json()
  //     }
  //   })
  //   .then(data => {
  //   })
  //   .catch(error => {
  //     console.log(error)
  //   })
  //
  //   this.setState({
  //     sorted: false,
  //     default: true
  //   })
  // }

  // handleRestoreGrid = () => {
  //   fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/admin/updateLayout?layout=${''}`, {
  //     method: 'POST',
  //     headers: {
  //       'token': Cookies.get('token')
  //     }
  //   })
  //   .then(response => {
  //     if(response.ok === true) {
  //       return response.json()
  //     }
  //   })
  //   .then(data => {
  //     // console.log(data)
  //   })
  //   .catch(error => {
  //     console.log(error)
  //   })
  //
  //   this.setState({
  //     sorted: false,
  //     default: false,
  //   })
  //
  //   window.location.reload()
  // }

  // handleRemoveNotification = (e, key) => {
    // console.log(key)
    // console.log(this.props.alerts)
  // }

    //
    // let addPanelList = this.props.currentUser.db_owner === 'KHOOK' ?
    //   this.props.homeList.filter(item => item.title !== 'Demographics').filter(item => filteredItems.indexOf(item) === -1)
    //   :  this.props.homeList.filter(item => filteredItems.indexOf(item) === -1)
    if(!sortedList) return <CircularProgress />


    let filteredList = usersList.indexOf(user) !== -1 ? sortedList.filter(
      ({id}) => {
        return id === 1
    }) : dbO === "KHOOK" ? sortedList.filter(
      ({title}) => {
        return (title !== "Demographics" && title.toLowerCase().indexOf(search.toLowerCase()) !== -1)
    }) :
    sortedList.filter(({title}) => {
      return title.toLowerCase().indexOf(search.toLowerCase()) !== -1
    })

    let addPanelList = dbO === "KHOOK" ?
    homeList.filter((item, {title}) => title !== 'Demographics' && filteredList.indexOf(item) == -1)
    : homeList.filter(item => filteredList.indexOf(item) == -1)

    const renderMenuOptions = () => (
      filteredList.map(({title}) => (
        <MenuItem>{title}</MenuItem>
      ))
    )

    return(
      <div className="home-grid">
        <div className="home-filters">
          <div className="search">
            {darkTheme ? 
              <StyledTextField
                variant="outlined"
                size="small"
                label="Search"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon fontSize="small"/>
                    </InputAdornment>
                  )
                }}
                value={search}
                onChange={updateSearch}
                onClick={openSearchList}
                // onFocus={openSearchList}
                // onBlur={closeSearchList}
              />
            :
              <StyledTextFieldLt
                variant="outlined"
                size="small"
                label="Search"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <SearchIcon fontSize="small"/>
                    </InputAdornment>
                  )
                }}
                value={search}
                onChange={updateSearch}
                onClick={openSearchList}
                // onFocus={openSearchList}
                // onBlur={closeSearchList}
              />
            }

            {/* <Menu
              anchorEl={openSearch}
              open={Boolean(openSearch)}
              onClose={closeSearchList}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left'
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left'
              }}
            >
              {renderMenuOptions()}
            </Menu> */}

            {/* <Tooltip title="View Panels List">
              <IconButton
                // className={this.props.currentUser.userID === 44 || this.props.currentUser.userID === 1045 || this.props.currentUser.userID === 370 ? classes.hidden : classes.iconbutton}
                size="small"
                disableRipple
                onClick={handleTogglePanelMenu}
                style={{marginLeft: "5px"}}
                >
                  <AppsIcon className="home-filter-icons"/>
                </IconButton>
              </Tooltip> */}
            </div>

            {/* <Menu
              anchorEl={anchor}
              getContentAnchorEl={null}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              transformOrigin={{
                vertical: 'bottom',
                horizontal:'left',
              }}
              keepMounted
              open={Boolean(anchor)}
              onClose={handleTogglePanelMenuClose}
            >
              {addPanelList.length > 0 ?
                <div>
                  <Typography variant="caption" style={{textDecoration: 'underline', color: '#ff3c51', marginLeft: '20px'}}>Screens Not Displayed On The Dashboard</Typography>
                  {addPanelList.map(({title, icon}) => (
                    <MenuItem dense key={title} className={classes.menuItem}>
                      {console.log(title)}
                      <div style={{display: 'flex'}}>
                        <Icon style={{marginRight: '10px'}}>{icon}</Icon>
                        <Typography>{title}</Typography>
                      </div>
                      <div>
                        <Tooltip title="Add Screen to Dashboard">
                          <IconButton size="small" onClick={e => handleAddPanel(e, row)}>
                            <AddToQueueIcon style={{fontSize: '14px', color: '#6dd141'}} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </MenuItem>
                  ))}
                  <Divider style={{marginBottom: '10px', marginTop: '10px'}}/>
                  <Typography variant="caption" style={{textDecoration: 'underline', color: '#52a22f', marginLeft: '20px'}}>Screens Displayed On The Dashboard</Typography>
                  {homeList.filter(item => addPanelList.indexOf(item) === -1).map(({title, icon}) => (
                    <MenuItem dense key={title} className={classes.menuItem}>
                      <div style={{display: 'flex'}}>
                        <Icon style={{marginRight: '10px', color: '#6a6a6a'}}>{icon}</Icon>
                        <Typography style={{color: '#6a6a6a'}}>{title}</Typography>
                      </div>
                      <div>
                        <Tooltip title={`Search for ${title}`}>
                          <IconButton size="small" onClick={e => this.updateSearch(e, row)}>
                            <SearchIcon style={{fontSize: '14px'}} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </MenuItem>
                  ))}
                </div>
                :
                <div>
                  <Typography variant="caption" style={{textDecoration: 'underline', color: '#52a22f', marginLeft: '20px'}}>Screens Displayed On The Dashboard</Typography>
                  {homeList.map(({title, icon}) => (
                    <MenuItem dense key={title} className={classes.menuItem}>
                      <div style={{display: 'flex'}}>
                        <Icon style={{marginRight: '10px', color: '#6a6a6a'}}>{icon}</Icon>
                        <Typography style={{color: '#6a6a6a'}}>{title}</Typography>
                      </div>
                      <div>
                        <Tooltip title={`Search for ${title}`}>
                          <IconButton size="small" onClick={e => this.updateSearch(e, row)}>
                            <SearchIcon style={{fontSize: '14px'}} />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </MenuItem>
                  ))}
              </div>
              }
            </Menu> */}
            <div className="sort" disabled>
              <Tooltip title="Save Changes">
                <IconButton
                  // className={this.props.currentUser.userID === 44 || this.props.currentUser.userID === 1045 || this.props.currentUser.userID === 370 ? classes.hidden : classes.iconbutton}
                  size="small"
                  disableRipple
                  // onClick={(e) => this.handleSaveGrid(e, filteredItems)}
                  // style={this.state.sorted ? {} : {display: 'none'}}
                  disabled
                >
                  <SaveIcon className="home-icons-disabled"/>
                </IconButton>
              </Tooltip>

              <Tooltip title="Restore Default">
                <IconButton
                  // className={this.props.currentUser.userID === 44 || this.props.currentUser.userID === 1045 || this.props.currentUser.userID === 370 ? classes.hidden : classes.iconbutton}
                  size="small"
                  disableRipple
                  // onClick={this.handleRestoreGrid}
                  // style={this.state.sorted || this.state.default ? {} : {display: 'none'}}
                  disabled
                  style={{marginRight: "5px"}}
                >
                  <RestorePageIcon className="home-icons-disabled"/>
                </IconButton>
              </Tooltip>

              {/* <Button
                variant="outlined"
                disableRipple
                className="home-filter-btn"
                style={{marginRight: "7px"}}
                endIcon={<BiFilter />}
                disabled
              >
                Filter
              </Button> */}

              {/* <StyledTextField
                variant="outlined"
                size="small"
                label="Sort by"
                value={sortVal}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      {Boolean(anchor) ?
                        <BiCaretUp />
                      :
                        <BiCaretDown />
                      }
                    </InputAdornment>
                  )
                }}
                onClick={handleOpenSortMenu}
                onChange={handleSortValueChange}
                className="sort-input"
                disabled
              /> */}

              <Menu
                open={Boolean(anchor)}
                anchorEl={anchor}
                onClose={handleCloseSortMenu}
                value={sortVal}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "right",
                }}
              >
                <MenuItem value={"DEFAULT"} onClick={(e) => handleSortValueChange(e, "DEFAULT")}>DEFAULT VIEW</MenuItem>
                <MenuItem value={"A TO Z"} onClick={(e) => handleSortValueChange(e, "A TO Z")}>SORT A TO Z</MenuItem>
                <MenuItem value={"Z TO A"} onClick={(e) => handleSortValueChange(e, "Z TO A")}>SORT Z TO A</MenuItem>
              </Menu>
            </div>
        </div>

        {/* <Drawer>

        </Drawer> */}
        <div>
          <SortableContainer
            onSortEnd={onSortEnd}
            axis={'xy'}
            useDragHandle
            useWindowAsScrollContainer
            transitionDuration={500}
          >
            {filteredList.map((value, index) => (
              <SortableItem
                key={value.title}
                index={index}
                value={value}
                removePanel={() => handleRemovePanel(value.title)}
                itemsLength={filteredList.length}
                darkMode={darkTheme}
              />
            ))}
          </SortableContainer>
        </div>
    </div>
    )
}
